import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import "./_style.scss";
import {imageCdnUrls} from "../common/ImageCdnUrls";
import {SearchInput, SmallLoader} from "Ncontracts.Common.UI";
import {CommunicationModel} from "../../Models/communications/communicationModel";
import {getCommunication, sendCommunication} from "../../actions/communications/communicationsAction";
import isEmpty from "../../helpers/isEmpty";
import _ from "lodash";
import LoadingOverlay from "../common/LoadingOverlay";
import CommunicationDetailHeader from "./CommunicationDetailHeader";
import DonutChart from "../common/DonutChart/DonutChart";
import getPaletteColors from "../../helpers/colorPaletteHelper";

class CommunicationDetail extends Component {

    static propTypes = {
        communication: PropTypes.shape(CommunicationModel),
        communicationSuccessfullyDeleted: PropTypes.bool,
        communicationSuccessfullySent: PropTypes.bool,
        getCommunicationDetails: PropTypes.func,
        history: PropTypes.object,
        isLoadingOverlayShowing: PropTypes.bool,
        match: PropTypes.object,
        sendCommunication: PropTypes.func,
        showErrorAlert: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.props.getCommunicationDetails(this.props.match.params.id);

        this.state = {
            searchValue: '',
            showPopover: false,
            sortBy: 'displayName',
            sortDir: 'asc',
        };
    }

    renderOverviewPanel = () => {
        const {title, message, recipientCount, emailCount, smsCount, voiceCount} = this.props.communication;
        return (
            <div className="communication-overview-panel columns is-mobile">
                <div className="communication-content column">
                    <div className="communication-overview-header">Message</div>
                    <div className="communication-title">{title}</div>
                    <div className="communication-message">{message}</div>
                </div>
                <div className="total-recipients column is-narrow">
                    <div className="recipient-count-label">Recipients</div>
                    <div className="recipient-count-with-icon">
                        <img src={imageCdnUrls.users} width="56" height="56"/>
                        <div>{recipientCount}</div>
                    </div>
                </div>
                <div className="delivery-method-counts column is-narrow">
                    <div className="method-header">Method</div>
                    <div className="delivery-count-with-icon">
                        <img src={imageCdnUrls.comm_email} width="30" height="25"/>
                        <div>{isEmpty(emailCount) ? 0 : emailCount}</div>
                    </div>
                    <div className="delivery-count-with-icon sms">
                        <img src={imageCdnUrls.comm_text} width="29" height="25"/>
                        <div>{isEmpty(smsCount) ? 0 : smsCount}</div>
                    </div>
                    <div className="delivery-count-with-icon voice">
                        <img src={imageCdnUrls.comm_voice} width="26" height="25"/>
                        <div>{isEmpty(voiceCount) ? 0 : voiceCount}</div>
                    </div>
                </div>
            </div>
        );
    };

    renderPollPanel = () => {
        const {includesPoll, poll, status} = this.props.communication;
        if (!includesPoll) return undefined;

        const {question, options, noResponseCount} = poll;

        let chartData = options.map(o => { return {name: o.text, value: o.responseCount}; });
        const atLeastOneResponse = options.some(o => o.responseCount > 0);
        if (noResponseCount > 0) chartData.push({name: 'No response', value: noResponseCount});

        const resultsBody = status === 'Draft' || !atLeastOneResponse ? <div className="no-results">No results</div> :
            <div className="poll-results-detail columns is-mobile">
                <div className="poll-chart column is-narrow">
                    <DonutChart width={170} data={chartData}/>
                </div>
                {this.renderChartKey(chartData, noResponseCount)}
            </div>;

        return (
            <div className="poll-panel columns is-mobile">
                <div className="poll-question-column column">
                    <div className="poll-question-header">Poll Question</div>
                    <div className="poll-question">{question}</div>
                    <div className="poll-options">
                        {options.map((o, index) => <div className="option-text" key={index}>{o.text}</div>)}
                    </div>
                </div>
                <div className="poll-results column">
                    <div className="poll-results-header">Poll Results</div>
                    {resultsBody}
                </div>
            </div>
        );
    };

    renderChartKey = (chartData, noResponseCount) => {
        const {options} = this.props.communication.poll;

        let colors = getPaletteColors(chartData.length);
        let optionColors = _.orderBy(chartData, 'value', 'desc').map((o, index) => {
            return {text: o.name, color: colors[index]};
        });

        return (
            <div className="poll-data column">
                {options.map((o, index) => <div className="option-with-count" key={index}>
                    <div className="option-text">
                        <div className="option-color"
                             style={{backgroundColor: _.find(optionColors, ['text', o.text]).color}}/>
                        {o.text}
                    </div>
                    <div className="response-count">{o.responseCount}</div>
                </div>)}
                {noResponseCount === 0 ? undefined :
                    <div className="option-with-count">
                        <div className="option-text">
                            <div className="option-color"
                                 style={{backgroundColor: _.find(optionColors, ['text', 'No response']).color}}/>
                            No response
                        </div>
                        <div className="response-count">{noResponseCount}</div>
                    </div>}
            </div>
        );
    };

    renderRecipientsList = () => {
        const {status, includesPoll} = this.props.communication;
        const noPoll = status === 'Draft' || !includesPoll;

        const responseDateHeader = noPoll ? undefined :
            <div className="poll-response-date-header column">
                <span className="column-header" onClick={() => this.updateSort('pollResponseDate')}>
                    Response {this.getSortIcon('pollResponseDate')}
                </span>
            </div>;

        const responseHeader = noPoll ? undefined :
            <div className="poll-response-header column">
                <span className="column-header" onClick={() => this.updateSort('pollResponse')}>
                    Answer {this.getSortIcon('pollResponse')}
                </span>
            </div>;

        return (
            <div className="recipients-list nc-list">
                <div className="list-header columns is-mobile">
                    <div className="name-header column">
                        <span className="column-header" onClick={() => this.updateSort('displayName')}>
                            Name {this.getSortIcon('displayName')}
                        </span>
                    </div>
                    <div className="method-header column is-narrow has-text-centered">
                        Method
                    </div>
                    {responseDateHeader}
                    {responseHeader}
                </div>
                <div className="list-body">
                    {this.renderRecipientRows(noPoll)}
                </div>
            </div>
        );
    };

    renderRecipientRows = excludePollResponses => {
        return this.getFilteredAndSortedRecipients().map(recipient => {
            const emailIcon = recipient.notificationMethods.includes('email') ? <img src={imageCdnUrls.comm_email} width="30" height="25"/> : undefined;
            const textIcon = recipient.notificationMethods.includes('sms') ? <img src={imageCdnUrls.comm_text} width="29" height="25"/> : undefined;
            const voiceIcon = recipient.notificationMethods.includes('voice') ? <img src={imageCdnUrls.comm_voice} width="26" height="25"/> : undefined;

            return (
                <div className="list-row columns is-mobile" key={recipient.id}>
                    <div className={`column name-column ${isEmpty(recipient.pollResponse) && !excludePollResponses ? 'no-response' : ''}`}>
                        {recipient.displayName}
                    </div>
                    <div className="column method-column is-narrow has-text-centered">
                        {emailIcon}
                        {textIcon}
                        {voiceIcon}
                    </div>
                    {excludePollResponses ? undefined : <div className="column">{recipient.pollResponseDateString}</div>}
                    {excludePollResponses ? undefined : <div className="column">{recipient.pollResponse}</div>}
                </div>
            );
        });
    };

    handleSearchValueChange = newValue => {
        this.setState({ ...this.state, searchValue: newValue });
    };

    getSortIcon = columnName => {
        if (this.state.sortBy !== columnName) return undefined;

        return <img className="sort-icon"
                    src={imageCdnUrls[`caret_${this.state.sortDir === 'asc' ? 'up' : 'down'}_grey`]}
                    width="12"
                    height="6"/>;
    };

    updateSort = columnName => {
        this.setState({
            ...this.state,
            sortBy: columnName,
            sortDir: this.state.sortBy === columnName && this.state.sortDir === 'asc' ? 'desc' : 'asc'
        });
    };

    getFilteredAndSortedRecipients = () => {
        const {searchValue, sortBy, sortDir} = this.state;
        const {status, includesPoll} = this.props.communication;

        const filteredList = this.props.communication.recipients.filter(recipient => {
            let notificationMethods = recipient.notificationMethods.slice();
            if (notificationMethods.includes('sms')) notificationMethods.push('text');
            if (notificationMethods.includes('voice')) notificationMethods.push('phone', 'call');
            const pollResponseMatchesSearch = status !== 'Draft' && includesPoll && !isEmpty(recipient.pollResponse) &&
                                              recipient.pollResponse.toLowerCase().includes(searchValue.toLowerCase());

            return (
                isEmpty(searchValue) ||
                recipient.displayName.toLowerCase().includes(searchValue.toLowerCase()) ||
                notificationMethods.includes(searchValue.toLowerCase()) ||
                pollResponseMatchesSearch
            );
        });

        return _.orderBy(filteredList, sortBy, sortDir);
    };

    render() {
        const {communication, communicationSuccessfullyDeleted, communicationSuccessfullySent} = this.props;

        if (communicationSuccessfullySent) {
            this.props.history.push("/communications/sent");
        }

        if (communicationSuccessfullyDeleted) {
            this.props.history.push("/communications/deleted");
        }

        if (isEmpty(communication)) return <div className="communications-container"><SmallLoader/></div>;

        return (
            <div className="communications-container has-back-link">
                {this.props.isLoadingOverlayShowing ? <LoadingOverlay/> : undefined}
                <div className="communication-detail-page">
                    <CommunicationDetailHeader communication={communication}/>
                    {this.renderOverviewPanel()}
                    {this.renderPollPanel()}
                    <div className="recipients-section">
                        <div className="search-header">
                            <SearchInput
                                tooltipText="Search"
                                isRightToLeft
                                onValueChange={newValue => this.handleSearchValueChange(newValue)}
                                placeholder="Search" delay={500}/>
                        </div>
                        {this.renderRecipientsList()}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    communication: state.communications.selectedCommunication,
    communicationSuccessfullyDeleted: state.communications.communicationSuccessfullyDeleted,
    communicationSuccessfullySent: state.communications.communicationSuccessfullySent,
    isLoadingOverlayShowing: state.communications.posting,
    showErrorAlert: state.communications.showErrorAlert,
});

const mapDispatchToProps = dispatch => ({
    getCommunicationDetails: id => dispatch(getCommunication(id)),
    sendCommunication: id => dispatch(sendCommunication(id)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CommunicationDetail));
